/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Teams_Custom_Page_CountInputs */

const en_tables_teams_custom_page_count = /** @type {(inputs: Tables_Teams_Custom_Page_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Page Count`)
};

const de_tables_teams_custom_page_count = /** @type {(inputs: Tables_Teams_Custom_Page_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Zusatzseiten`)
};

/**
* | output |
* | --- |
* | "Custom Page Count" |
*
* @param {Tables_Teams_Custom_Page_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_teams_custom_page_count = /** @type {((inputs?: Tables_Teams_Custom_Page_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Teams_Custom_Page_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_teams_custom_page_count(inputs)
	return de_tables_teams_custom_page_count(inputs)
});